import { TextTag as Text } from "../../atoms"
import React from "react"
import bubbleArt from "../../assets/images/bubble_art.svg"
import taglineBubble from "../../assets/images/section1_bubble.svg"
import RegisterNewUserByEmail from "../../components/RegisterNewUserByEmail/RegisterNewUserByEmail"
import "./RegisterNewUserPage.scss"
import { SIGNUP_TEXT, SUB_TAGLINE } from "../../constants/messages"
import coupleArt from "../../assets/images/couple_art.gif"
import HomePageInfo from "../../components/HomePage/HomePageInfo"

const RegisterNewUserPage = () => {
  return (
    <div id="RegisterNewUserPage">
      <div className="home-background">
        <div className="sideLeft">
          <div className="reverse-content">
            <div className="couple-art-box">
              <img className="couple-art" src={coupleArt} alt="coupleSeat" />
            </div>
            <div className="jomo-text">
              <div className="tagline">
                <img
                  className="bubble-set"
                  src={taglineBubble}
                  alt="Closer together"
                />
                <Text textType="taglineBold">{SIGNUP_TEXT}</Text>
              </div>
              <div className="sub-tagline">
                <Text textType="bodyHeading">{SUB_TAGLINE} </Text>
              </div>
            </div>
          </div>
        </div>
        <div className="sideRight">
          <div className="signupBg">
            <div>
              <RegisterNewUserByEmail />
            </div>
          </div>
          <div className="bubble-set-box">
            <img className="bubble-set" src={bubbleArt} alt="bubbles" />
          </div>
        </div>
      </div>
      <HomePageInfo />
    </div>
  )
}

export default RegisterNewUserPage
